<template>
  <div class="payments__instruments_item pnm-venmo-withdrawal" 
    :class="{'diss': !customerCanWithdraw}" 
    v-if="isPNMVenmoWithdrawalAvailable" 
    @click.stop="go2PNMVenmoWithdrawal()" 
    ref="pnmVenmo">
    <span class="piitem-picture"><img :src="mediaServer('/static/brand-img/' + brandKey + '/venmo.svg')" alt="venmo"/></span>
    <span class="piitem-text">
       <div class="piitem-text-headline">{{ $t('Payments.PNM.Venmo.Headline') }}</div>
       <div class="piitem-text-desc">{{ $t('Payments.PNM.Venmo.Desc') }}</div>
    </span>
    <span class="piitem-arrow"><v-icon>chevron_right</v-icon></span>
  </div>
</template>
<script>
import store from '@/store'
import Url from '@/components/mixins/Url'
import Branding from '@/components/mixins/Branding'

export default {
  mixins: [Url, Branding],
  computed: {
    isPNMPushDebitAvailable () {
      return store.getters['pnmGateway/pnmPushDebit/isPNMPushDebitAvailable']
    },
    isPNMVenmoAvailable () {
      return store.getters['pnmGateway/pnmVenmo/isPNMVenmoAvailable']
    },
    isPNMVenmoWithdrawalAvailable () {
      return this.isPNMPushDebitAvailable && this.isPNMVenmoAvailable
    },
    transactionType () {
      return store.getters['payments/transactionType']
    },
    withdrawType () {
      return this.transactionType && this.transactionType === 'withdrawal'
    },
    customerContext () {
      return store.getters['getCustomerContext']
    },
    customerCanWithdraw () {
      return this.customerContext && this.customerContext.ActionWithdraw
    }
  },
  methods: {
    go2PNMVenmoWithdrawal () {
      if (this.customerCanWithdraw) {
        this.$router.push({name: 'pnm-venmo-withdrawal'})
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/payments/PayNearMeGateway/PNMVenmoWithdrawalItem.vue